module.exports = __webpack_public_path__ + "img/the-davenports.6035037f.png";